module.exports = __webpack_public_path__ + "img/mr_head_1ic0.2b36a9a3.jpg";